import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { IDueDiligenceUserListModel } from '../../../shared/models/DueDiligenceUserListModel';
import { MultipleEmailIdModel } from '../../../shared/models/MultipleEmailIdModel';
import { IResponseModel } from '../../../shared/models/ResponseModel';
import { LoaderService } from '../../../shared/providers/loader.service';
import { PropertyManagementService } from '../../../shared/providers/property-management.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { ValidationService } from '../../../shared/providers/validation.service';
import { FileUploadService } from '../../../shared/providers/fileupload.service';
import { IFileUpload } from '../../../shared/models/fileupload';
import { DashboardTabs } from '../../property-view.component';

interface IUserDDList {
  PropertyId: number;
  LoggedInUserId: number;
  EmailForShare: string[];
  Source: string;
  OMApproval: boolean;
  DDApproval: boolean;
  CAApproval: boolean;
}

@Component({
  selector: 'app-add-user-to-dd',
  templateUrl: './add-user-to-dd.component.html',
  styleUrls: ['./add-user-to-dd.component.css']
})
export class AddUserToDDComponent implements OnInit {

  @Input() PropertyId: number = 0;
  @Input() Source: string = '';
  @Input() Type: string = 'DueDiligence';
  @Input() IsAgreementRequired: boolean = false;
  @Input() OMRequireApproval: boolean = false;
  @Input() DDRequireApproval: boolean = false;
  @Input() modalRef: BsModalRef;
  modalRefDelete: BsModalRef;
  @Input() propertyGuid: string = '';
  mailIds: MultipleEmailIdModel[];
  UserList: IDueDiligenceUserListModel[];
  keyCode: number[];
  user: any;
  loaderService: any;
  response = {} as IResponseModel;
  shareListing = {} as IUserDDList;
  selectedUserId: number = 0;
  totalCount: number = 0;
  selectedusername: string = '';
  fileUploadType: string = "single";
  clearFiles: number = 0;
  inputFileUploadForLOI = {} as IFileUpload;
  fileExtensionType: string = "document";
  fileTypes = '.PDF';
  IsConfidentialityAgreementChecked: boolean = false;
  OMApproval: boolean = false;
  DDApproval: boolean = false;
  IsUploadOpen: boolean = false;
  selectedFiles: string[] = [];
  IsSingleUser: boolean = true;
  IsSubmit: boolean = false;
  constructor(private _propertyManagementService: PropertyManagementService, private _fileUploadService: FileUploadService, private loaderServices: LoaderService, private router: Router, public authService: AuthenticationService, private _toastService: ToastService, private modalService: BsModalService, public _validationService: ValidationService) { }

  ngOnInit(): void {
    this.mailIds = [];
    this.keyCode = [32, 188, 13];
    this.user = this.authService.user != null ? this.authService.user : '';
    this.getAccessUserDetails();
    this.setLink();
  }

  validEmail$(control: any) {

    if (control.value != "") {
      let serchfind: boolean;
      const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      serchfind = regexp.test(control.value);
      if (serchfind == false) {
        return {
          'validEmail$': true
        };
      }
    }
    return null;
  }
  openModal(template: TemplateRef<any>, classes: any, id: number, name: string) {
    this.selectedUserId = id;
    this.selectedusername = name;
    this.modalRefDelete = this.modalService.show(template, { class: classes });
  }
  rejectDocRequest() {
    this.modalRef.hide();
    this.modalRefDelete.hide();
    window.scrollTo(0, 0);
    var userId = this.selectedUserId;
    let action = 'reject';
    let url = this.currentRedirectUrl1 + "&action=" + action;
    if (userId > 0) {
      if (this.Type == 'DueDiligence') {
        this._propertyManagementService.revokeDuediligenceAccess(userId, this.PropertyId, this.user.Id).subscribe(response => {
          if (response.toString() == 'true') {
            this._toastService.addToast({
              title: 'Success', msg:
                'Access revoked successfully', timeout:
                5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
            });
          }
          else {
            this._toastService.addToast({
              title: 'Error', msg:
                'Error Occured', timeout:
                5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
            });
          }
          this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
          };
          window.scrollTo(0, 0);
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
            this.router.navigateByUrl(url));

        });

      }
      else {
        this._propertyManagementService.revokeOMAccess(userId, this.PropertyId, this.user.Id).subscribe(response => {
          if (response.toString() == 'true') {
            this._toastService.addToast({
              title: 'Success', msg:
                'Access revoked successfully', timeout:
                5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
            });
          }
          else {
            this._toastService.addToast({
              title: 'Error', msg:
                'Error Occured', timeout:
                5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
            });
          }
          this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
          };
          window.scrollTo(0, 0);
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
            this.router.navigateByUrl(url));

        });

      }
    }
  }

  public errorMessages = {
    'validEmail$': 'Invalid Email Address'
  };

  public validators = [this.validEmail$];

  AddUser() {
    this.IsSubmit = true;
    let valid = true;
    if (this.mailIds.length == 0) {
      valid = false;
      this.IsSubmit = false;
      this._toastService.addToast({ title: 'Error Occured ', msg: 'Please Enter the Email Address', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    }
    let validateform = this.checkFormSubmit();
    if (!validateform) {
      if (valid) {
        this._toastService.addToast({ title: 'Error Occured ', msg: 'Please select any of the approval', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
      this.IsSubmit = false;
      valid = false;
    }
    if (this.IsAgreementRequired && this.IsConfidentialityAgreementChecked && this.IsSingleUser) {
      if (this.selectedFiles == null || this.selectedFiles == undefined || this.selectedFiles.length < 1) {
        this._toastService.addToast({ title: 'Error', msg: 'Please Upload the document', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        valid = false;
        this.IsSubmit = false;
      }
    }
    if (valid) {
      this.loaderServices.display(true);
      this.shareListing.EmailForShare = this.mailIds.map(function (data) { return data.value });
      this.shareListing.PropertyId = this.PropertyId;
      this.shareListing.LoggedInUserId = this.user.Id;
      this.shareListing.OMApproval = this.OMApproval;
      this.shareListing.DDApproval = this.DDApproval;
      this.shareListing.CAApproval = this.IsConfidentialityAgreementChecked;
      this.shareListing.Source = this.Type;
      this.IsSubmit = false;
      this._propertyManagementService.checkduplicateUserInDocAccessRequest(this.shareListing).subscribe(res => {
        if (!res) {

          var successmessage = 'User added successfully';
          this._propertyManagementService.AddUserToDD(this.shareListing).subscribe(res => {
            this.response = res;
            if (this.response.IsSuccess) {
              if (this.IsConfidentialityAgreementChecked && this.IsSingleUser && this.IsAgreementRequired) {
                let FileName = '';
                if (this.selectedFiles != null) {
                  let currentFile = this.selectedFiles[0];
                  if (currentFile != null && currentFile != undefined && currentFile['name'] != null && currentFile['name'] != undefined) {
                    FileName = currentFile['name'];
                    if (FileName.length > 150) {
                      FileName = ''
                    }
                  }

                }
                this.inputFileUploadForLOI.documentName = FileName == '' ? this.Type == 'OM' ? "ConfidentialityAgreementT&C.pdf" : 'DueDiligenceT&C.pdf' : FileName;
                this.inputFileUploadForLOI.fileCategoryId = this.Type == 'OM' ? 409 : 410;
                this.inputFileUploadForLOI.objectId = this.response.Id;
                this.inputFileUploadForLOI.objectTypeId = 304;
                this.inputFileUploadForLOI.type = "Documents";
                this.inputFileUploadForLOI.IsConfidentialityAgreementDoc = true;
                this.inputFileUploadForLOI.id = this.response.Id;
                this._fileUploadService.uploadFiles(this.inputFileUploadForLOI, this.selectedFiles).subscribe(response => {
                  this._toastService.addToast({
                    title: 'Success',
                    msg: successmessage,
                    timeout: 5000,
                    theme: 'bootstrap',
                    position: 'bottom-right',
                    type: 'success'
                  });
                  this.modalRef.hide();
                  this.loaderServices.display(false);
                  window.scrollTo(0, 0);
                  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
                    this.router.navigateByUrl(this.currentRedirectUrl1));
                });
              }
              else {
                this._toastService.addToast({
                  title: 'Success',
                  msg: successmessage,
                  timeout: 5000,
                  theme: 'bootstrap',
                  position: 'bottom-right',
                  type: 'success'
                });
                this.modalRef.hide();
                this.loaderServices.display(false);
                window.scrollTo(0, 0);
                if (this.currentRedirectUrl1.indexOf('Dashboard') > -1) {
                  localStorage.setItem('property-dashboard-Tab', this.dashboardTabs.DocAccess.toString());
                }
                this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
                  this.router.navigateByUrl(this.currentRedirectUrl1));
              }

            }
            else {
              this._toastService.addToast({ title: 'Error Occured ', msg: this.response.ErrorMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
              this.modalRef.hide();
              this.loaderServices.display(false);
              window.scrollTo(0, 0);
              if (this.currentRedirectUrl1.indexOf('Dashboard') > -1) {
                localStorage.setItem('property-dashboard-Tab', this.dashboardTabs.DocAccess.toString());
              }
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
                this.router.navigateByUrl(this.currentRedirectUrl1));

            }

          });
        }
        else {
          this.loaderServices.display(false);
          this._toastService.addToast({ title: 'Error', msg: 'Users are already added to the Vault', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }
      });
    }
  }

  getAccessUserDetails() {
    this._propertyManagementService.GetDueDiiligenceUserList(this.PropertyId, this.Type).subscribe(response => {
      this.UserList = response;
      if (this.UserList != null && this.UserList.length > 0) {
        this.totalCount = this.UserList.length;
      }
    });
  }


  public currentRedirectUrl1: string = '';
  dashboardTabs = DashboardTabs;

  setLink() {
    let activeTab = '';

    if (this.Source == 'Duediligence') {
      activeTab = 'Diligence';
    }
    else if (this.Source == 'OM') {
      activeTab = 'Memorandom';
    }
    else {
      activeTab = 'Dashboard';
    }
    this.currentRedirectUrl1 = "/viewproperty/" + this.propertyGuid + "?tab=" + activeTab;
  }

  selectedFilesListEmitter(selectedFilesListEmitter: string[]) {
    this.selectedFiles = selectedFilesListEmitter;

    if (this.selectedFiles.length > 0) {
      let currentFile = this.selectedFiles[0];
      if (currentFile != null && currentFile != undefined && currentFile['name'] != null && currentFile['name'] != undefined) {

        if (currentFile['type'] === 'application/pdf') {
        }
        else {
          this._toastService.addToast({
            title: 'Error Extension',
            msg: `Please upload pdf files`,
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'error'
          });
          this.selectedFiles = [];
        }

      }
    }
  }

    openFileUpload(isVisible) {
      if (this.IsAgreementRequired) {
        this.IsUploadOpen = isVisible;
      }
    }
    showConfidentialityAgreement() {
      if (this.mailIds != null && this.mailIds.length == 1 && this.IsAgreementRequired) {
        this.IsSingleUser = true;
      }
      else {
        this.IsSingleUser = false;
        this.selectedFiles = [];
        this.IsConfidentialityAgreementChecked = false;
        this.IsUploadOpen = false;
      }
    }

    checkFormSubmit() {
      let status = false;
      if (this.OMRequireApproval && this.OMApproval) {
        status = true;
      }
      if (this.DDRequireApproval && this.DDApproval) {
        status = true;
      }
      if (this.IsSingleUser && this.IsAgreementRequired && this.IsConfidentialityAgreementChecked) {
        status = true;
      }
      return status;
    }

  }
